<template>
  <div class="image-container">
    <message-bubble :isMine=isMine :message=message>
      <div v-for="(item, index) of showList" :style="item.type == 'text' ? {} : { 'display': 'inline-block' }">
        <div class="itemCls" v-if="item.type == 'text'">{{ item.value }}</div>
        <img v-if="item.type == 'image'" class="image-element" :src="item.value" @click="handlePreview(item.value)" />
      </div>
      <span v-if='message.uuid'>
        <p style="text-align: center;margin-bottom: 0;">
          <el-button @click.prevent="clickUp()" icon="icon iconfont icondianzan1" class="btnCls" :style="(upalreadyClicked || downalreadyClicked) ? { 'pointer-events': 'none' } : {}" :class="upalreadyClicked ? 'is-plain' : ''" size="mini">点赞一下</el-button>
          <el-button @click.prevent="openFeedback()" icon="icon iconfont icondiancai2" class="btnCls" :style="(upalreadyClicked || downalreadyClicked) ? { 'pointer-events': 'none' } : {}" :class="downalreadyClicked ? 'is-plain' : ''" size="mini">继续加油</el-button>
        </p>
      </span>
    </message-bubble>
    <div v-if="upordown == 'up'" class="helpfulFeedback">
      谢谢您给我的赞，我会继续努力。
    </div>
    <div v-if="upordown == 'over'" class="helpfulFeedback">
      抱歉，给您带来不好的体验，我会继续学习，下次为您提供更好的服务。
    </div>
    <div v-if="upordown == 'down'" class="helpfulFeedback downFeedback">
      <span class="title" style="display:flex;justify-content: center;font-size:14px">意见反馈</span>
      <div class="radio_box">
        <el-radio v-model="feedback" :label="item" size="medium" class="item" v-for="(item, index) in eval_class" :key="index">{{ item }}</el-radio>
      </div>
      <el-input type="textarea" class="textarea" placeholder="请输入意见" v-model="textarea" v-if="feedback" maxlength="300" show-word-limit>
      </el-input>
      <button @click="submitFeedback" class="fbSubBtn">提交</button>
    </div>
  </div>
</template>

<script>
import MessageBubble from '../message-bubble'
import { mapState } from 'vuex'
import sessionAPI from '@/api/session'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      showList: [],
      upordown: null,
      feedback: '',
      textarea: '',
      upalreadyClicked: false,
      downalreadyClicked: false,
    }
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean
    }
  },
  mounted() {
    this.showList = JSON.parse(this.message.content)
  },
  components: {
    MessageBubble,
  },
  computed: {
    ...mapState({
      zhujianAppId: state => state.user.zhujianAppId,
      eval_class: state => state.conversation.eval_class
    }),
  },
  methods: {
    scrollToBottom() {
      const dom = document.querySelector(".message-list")
      this.$nextTick(() => {
        if (!dom) {
          return
        }
        // dom.scrollTop = dom.scrollHeight
        dom.scrollTop += 200
      })
    },
    handlePreview(url) {
      this.$bus.$emit('image-preview', {
        url: url
      })
    },
    clickUp() {
      this.upalreadyClicked = true
      let postData = {
        uuid: this.message.ID,
        feedback: 'helpful',
        customFeedback: '',
        timestamp: Math.round(this.message.createTime / 1000),
        appid: this.zhujianAppId
      }
      sessionAPI.getChatEval(postData).then(res => {
        if (res) {
          this.$message({
            showClose: true,
            message: res[0].value,
            type: 'success'
          })
          this.upordown = 'up'
          this.scrollToBottom()
        } else {
          this.$message({
            showClose: true,
            message: '点赞失败',
            type: 'error'
          })
        }
      }).catch(err => {
        console.log(err)
        this.$message({
          showClose: true,
          message: err.toString().indexOf('Error') > -1 ? '操作失败，请重试~' : err,
          type: 'error'
        })
      })
    },
    openFeedback() {
      this.downalreadyClicked = true
      this.upordown = 'down'
      this.scrollToBottom()
    },
    submitFeedback() {
      let postData = {
        uuid: this.message.ID,
        feedback: 'unhelpful',
        customFeedback: this.feedback + ';' + this.textarea,
        timestamp: Math.round(this.message.createTime / 1000),
        appid: this.zhujianAppId
      }
      if (!this.feedback) {
        this.$message({
          showClose: true,
          message: '请选择点踩原因',
          type: 'warning'
        })
      } else {
        sessionAPI.getChatEval(postData).then(res => {
          if (res) {
            this.$message({
              showClose: true,
              message: res[0].value,
              type: 'success'
            })
            this.upordown = 'over'
            this.scrollToBottom()
          } else {
            this.$message({
              showClose: true,
              message: '评价失败',
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: err.toString().indexOf('Error') > -1 ? '操作失败，请重试~' : err,
            type: 'warning'
          })
        })
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.itemCls
  max-width 440px
  padding: 12px 0;
.image-element
  max-width 200px
  max-height 300px
  border-radius 5px
  cursor zoom-in
.btnCls
  border: none;
  width: 47%;
  border-radius: 0;
  margin-left: 0 !important;
.btnCls:hover {
  background-color: #fff;
}
.btnCls:active {
  background-color: #fff !important;
}
.btnCls:first-child {
  border-right: 1px solid #DEDEDE;
}
.helpfulFeedback {
  background-color #fff;
  border-radius: 0 8px 8px 8px;
  padding: 12px 16px;
  margin-top: 15px;
}
.downFeedback {
  max-width: 480px;
  height auto
  padding: 16px;
}
.downFeedback span.title {
  font-size: 16px;
  font-weight: 400;
  color: #000;
  margin-bottom: 12px;
}
.radio_box {
  width 100%
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
}
.radio_box .item {
  flex: 1;
  padding: 0 35px;
  width: 15%;
  height: 28px;
  border: 1px solid rgba(222, 222, 222, 1);
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 12px!important;
  color: #666666;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  margin-right: 10px;
  padding-left: -3px;
}
.radio_box .item:nth-child(2n) {
}
.fbSubBtn {
  height: 28px;
  background: #00ACEB;
  border-radius: 4px;
  color: #fff;
  border: none;
  margin-top 20px
  width 100%
  cursor: pointer;
}
.is-plain{
    color: #409eff;
}
</style>
